import { Box, CircularProgress } from '@mui/material';

export default function LoadingPage() {
  return (
    <Box
      width="100vw"
      height="100vh"
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <CircularProgress />
    </Box>
  );
}
